<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wEcHW6/tc-custom/9781466837300.jpg?1719550414573" alt="This image is the cover for the book Dangerous When Wet"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dangerous When Wet
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"A blisteringly funny, wrenching account of wrestling way too close to—and later loose from—booze, sex and drugs and his adorable, infuriating mother. Bravo!" —Mary Karr, <i>New York Times </i>bestselling author of <i>The Liars' Club</i><br/></b><br/>"Whoever said you can't get sober for someone else never met my mother, Mama Jean. When I came to in a Manhattan emergency room after an overdose to the news that she was on her way from Texas, I panicked. She was the last person I wanted to see on that dark September morning, but the person I needed the most."<br/><br/>So begins this astonishing memoir—by turns both darkly comic and deeply poignant—about this native Texan's long struggle with alcohol, his complicated relationship with Mama Jean, and his sexuality. From the age of five all Brickhouse wanted was to be at a party with a drink in one hand and a cigarette in the other and all Mama Jean wanted was to keep him at that age, her Jamie doll forever. A Texan Elizabeth Taylor with the split personality of Auntie Mame and Mama Rose, always camera-ready and flamboyantly outspoken, Mama Jean haunted him his whole life, no matter how far away he went or how deep in booze he swam.<br/><br/>Brickhouse's journey takes him from Texas to a high-profile career in book publishing amid New York's glamorous drinking life to his near-fatal descent into alcoholism. After Mama Jean ushers him into rehab and he ultimately begins to dig out of the hole he'd found himself in, he almost misses his chance to prove that he loves her as much as she loves him. Bitingly funny, raw, and insightful, <i>Dangerous When Wet</i> is the unforgettable story of a unique relationship between a son and his mother.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jamie Brickhouse
      </h2>
      
      <p class="authorDescription body article">JAMIE BRICKHOUSE has been published in <I>The</I><I>New York Times,</I> the <I>International Herald Tribune,</I><I>Lambda Literary Review,</I><I>The Fix</I>, <I>Addiction/Recovery eBulletin,</I> and the Latin American travel magazine <I>Travesía. </I>He is also a guest blogger for the <I>Huffington Post</I>. Brickhouse spent over two decades in the publishing industry, most recently at two major houses as head of their publicity and lecture divisions. He has also performed stand-up comedy and recorded voice-overs for the legendary cartoon TV show, <I>Beavis and Butthead</I>. A native of Beaumont, Texas, Brickhouse lives in Manhattan with his partner, Michael.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?09d40838